import { NgModule } from '@angular/core';

import { SashaBreadcrumbComponent } from './sasha-breadcrumb.component';
import { BreadcrumbModule } from 'libraries/component/breadcrumb/breadcrumb.module';

@NgModule({
    imports: [
        BreadcrumbModule,
    ],
    declarations: [
        SashaBreadcrumbComponent,
    ],
    exports: [
        SashaBreadcrumbComponent,
    ],
})
export class SashaBreadcrumbModule {  }